<template>
  <footer class="py-5 border mt-4 border-radius-lg bg-gray-300">
    <div class="container  max-w-10">
      <div class="row mx-auto mb-2 text-center col-lg-8 color-blue">
        <div class="mx-auto mb-2 text-center col-lg-8">
          <h2 class="text-lg font-bold"> Centro de la Empresa la Industria y Los Servicios</h2>
          <h6 class="text-md"> Carrera 9 No 68-50, estaciones - PBX (60 8) 8757040 IP 83352</h6>
        </div>
        <div class="mx-auto mt-2 mb-4 text-center col-lg-8">
          <a
            href="https://www.facebook.com/SENA/"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-facebook"></span>
          </a>
          <a
            href="https://x.com/SENAComunica"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-x-twitter"></span>
          </a>
          <a
            href="https://www.instagram.com/senacomunica/"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-instagram"></span>
          </a>
          <a
            href="https://www.youtube.com/@SENAComunica"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-youtube"></span>
          </a>
          <a
            href="https://www.linkedin.com/school/servicio-nacional-de-aprendizaje-sena-/?originalSubdomain=co"
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-linkedin"></span>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <h6 class="mb-0 text-md font-extrabold">
            Copyright © {{ new Date().getFullYear() }} Servicios tecnologicos.
          </h6>
        </div>
      </div>
    </div>
  </footer>
</template>
